import type { ReactElement } from "react"
import { useHistory, useParams } from "react-router-dom"
import { useIndexTracking } from "../../../hooks"

import type { MapDto } from "../../../models"
import type { Breadcrumb, Chapter, LinkChapter, Region, Theme } from "../../../redux"
import { PageType } from "../../../redux"
import { PageContainer } from "../../molecules"
import { IndexViewer } from "../../organisms"

interface IRoutingParams {
  chapterId?: string
  themeId?: string
  regionId?: string
}

export function IndexPage(): ReactElement {
  const { chapterId, themeId, regionId } = useParams<IRoutingParams>()

  useIndexTracking(chapterId, themeId, regionId)

  const history = useHistory()

  function navigateToChapter(chapter: Chapter | LinkChapter): void {
    if ("url" in chapter) {
      window.open(chapter.url)
    } else {
      history.push(`/chapter/${chapter.id}`)
    }
  }

  function navigateToRegion(region: Region): void {
    history.push(`/region/${region.id}`)
  }

  function navigateToTheme(theme: Theme): void {
    history.push(`/theme/${theme.id}`)
  }

  function navigateToMap(map: MapDto): void {
    history.push(`/map/${map.id}`)
  }

  function onReturnToPage(page: Breadcrumb): void {
    switch (page.type) {
      case PageType.Chapter:
        history.push(`/chapter/${page.id}`)
        break
      case PageType.Region:
        history.push(`/region/${page.id}`)
        break
      case PageType.Theme:
        history.push(`/theme/${page.id}`)
        break
      case PageType.Index:
        history.push("/content")
    }
  }

  return (
    <PageContainer id="index-page" smallPadding>
      <IndexViewer
        chapterId={chapterId}
        themeId={themeId}
        regionId={regionId}
        onChapterClicked={navigateToChapter}
        onRegionClicked={navigateToRegion}
        onThemeClicked={navigateToTheme}
        onMapClicked={navigateToMap}
        returnToPage={onReturnToPage}
      />
    </PageContainer>
  )
}
